import { type FC } from 'react';
import styles from './Title.module.scss';

interface Props {
  title: string;
  description?: string;
}

export const Title: FC<Props> = ({ title, description }) => {
  return (
    <div>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
};
